<template>
  <div>
    <v-form v-model="valid" lazy-validation>
      <v-container :class="ui.bkgdColor">
        <div>
          <v-layout row :class="ui.textSubheading">
            <div class="ml-4 mt-4">
              Hazard Detail
            </div>
          </v-layout>
          <v-layout row wrap class="ml-2 mr-2">
            <v-flex xs12 md8 lg6>
              <v-select
                :change="updateFormChar()"
                v-model="reach"
                :label="this.localForm.reach"
                :items="hazardLevelOptions"
                color="wplblue0"
                prepend-icon="filter_list"
                hint="hazard reach"
                persistent-hint
              >
              </v-select>
            </v-flex>
            <v-flex xs12 md8 lg6>
              <v-select
                :change="updateFormChar()"
                v-model="cond"
                :label="this.localForm.cond"
                :items="hazardConditionOptions"
                color="wplblue0"
                prepend-icon="adjust"
                hint="condition"
                persistent-hint
              >
              </v-select>
            </v-flex>
          </v-layout>
          <v-layout row wrap class="ml-2 mr-2">
            <v-flex xs12 md8 lg6>
              <v-select
                :change="updateFormChar()"
                v-model="theme"
                :label="this.localForm.theme"
                :items="hazardThemeOptions"
                color="wplblue0"
                prepend-icon="error_outline"
                hint="hazard theme"
                persistent-hint
              >
              </v-select>
            </v-flex>
            <v-flex xs12 md8 lg6>
              <v-select
                :change="updateFormChar()"
                v-model="dis"
                :label="this.localForm.dis"
                :items="engineeringDisciplineOptions"
                color="wplblue0"
                prepend-icon="engineering"
                hint="discipline"
                persistent-hint
              >
              </v-select>
            </v-flex>
          </v-layout>
        </div>
        <div>
          <v-layout row :class="ui.textSubheading">
            <div class="ml-4 mt-4">
              Hazard Description
            </div>
          </v-layout>
          <v-layout row wrap class="ml-3 mr-2 mt-4">
            <v-flex xs12>
              <v-textarea
              :change="updateFormChar()"
              :color="ui.textColor"
              :background-color="ui.btnColor"
              v-model="localForm.des"
              :disabled="false"
              :outline="true"
              :rules="ruleMustBeNotUndefinedANDLessThan2000"
              hint="hazard commments"
              auto-grow
              persistent-hint
              ></v-textarea>
            </v-flex>
          </v-layout>
        </div>
        <v-layout row class="mb-4">
        </v-layout>
        <v-layout row class="mb-4">
        </v-layout>
      </v-container>
    </v-form>
  </div>
</template>

<script>
import docRevsModFunctions from "@/document/revisions/mixins/docRevsModFunctions.js";
import ruleTextfield from "@/data/rules/mixins/rulesTextfield.js";
import apptheme from "@/frame/theme/mixins/apptheme.js";
import hazardOptions from "@/data/options/mixins/hazardOptions.js";
import disciplineOptions from "@/data/options/mixins/disciplineOptions.js";

import { mapGetters } from "vuex";
export default {
  data() {
    return {
      valid: true,
      localForm: {
        cond: "",
        theme: "",
        reach: "",
        dis: "",
        des: ""
      },
      orgForm: {
        cond: "",
        theme: "",
        reach: "",
        dis: "",
        des: ""
      },
      reach: "",
      dis: "",
      cond: "",
      theme: ""
    };
  },
  beforeMount() {
    // fix orginal data before change
    this.localForm.reach = this.getDetail.char.reach;
    this.localForm.dis = this.getDetail.char.dis;
    this.localForm.cond = this.getDetail.char.cond;
    this.localForm.theme = this.getDetail.char.theme;
    this.localForm.des = this.getDetail.char.des;

    this.orgForm.reach = this.getDetail.char.reach;
    this.orgForm.dis = this.getDetail.char.dis;
    this.orgForm.cond = this.getDetail.char.cond;
    this.orgForm.theme = this.getDetail.char.theme;
    this.orgForm.des = this.getDetail.char.des;
  },
  watch: {
    dis() {
      this.localForm.dis = this.dis;
      this.updateFormChar();
    },
    cond() {
      this.localForm.cond = this.cond;
      this.updateFormChar();
    },
    theme() {
      this.localForm.theme = this.theme;
      this.updateFormChar();
    },
    reach() {
      this.localForm.reach = this.reach;
      this.updateFormChar();
    }
  },
  // eslint-disable-next-line
  mixins: [
    docRevsModFunctions,
    ruleTextfield,
    apptheme,
    hazardOptions,
    disciplineOptions
  ],
  computed: {
    ...mapGetters(["getDetail", "getDetailChar", "getCurrentPage"])
  },
  methods: {
    updateFormChar() {
      let char = this.getDetailChar;
      // eslint-disable-next-line
      if (
        this.localForm.reach !== this.orgForm.reach &&
        this.localForm.reach !== ""
      ) {
        // after the change re-assign new Local to Org
        this.orgForm.reach = this.localForm.reach;
        // basic
        char.reach = this.localForm.reach;
        this.$store.dispatch("changeDetailChar", char);
        this.saveDocumentRevMod(2.61, 1); // business mod.
        this.$store.dispatch("changeDataSavePendingIndication", true);
      }

      if (
        this.localForm.cond !== this.orgForm.cond &&
        this.localForm.cond !== ""
      ) {
        // after the change re-assign new Local to Org
        this.orgForm.cond = this.localForm.cond;
        // basic
        char.cond = this.localForm.cond;
        this.$store.dispatch("changeDetailChar", char);
        this.saveDocumentRevMod(3.14, 2); // business mod.
        this.$store.dispatch("changeDataSavePendingIndication", true);
      }

      if (
        this.localForm.theme !== this.orgForm.theme &&
        this.localForm.theme !== ""
      ) {
        // after the change re-assign new Local to Org
        this.orgForm.theme = this.localForm.theme;
        // basic
        char.theme = this.localForm.theme;
        this.$store.dispatch("changeDetailChar", char);
        this.saveDocumentRevMod(2.71, 3); // business mod.
        this.$store.dispatch("changeDataSavePendingIndication", true);
      }

      if (
        this.localForm.dis !== this.orgForm.dis &&
        this.localForm.dis !== ""
      ) {
        // after the change re-assign new Local to Org
        this.orgForm.dis = this.localForm.dis;
        // basic
        char.dis = this.localForm.dis;
        this.$store.dispatch("changeDetailChar", char);
        this.saveDocumentRevMod(2.71, 4); // business mod.
        this.$store.dispatch("changeDataSavePendingIndication", true);
      }

      if (
        this.localForm.des !== this.orgForm.des &&
        this.localForm.des !== ""
      ) {
        // after the change re-assign new Local to Org
        this.orgForm.des = this.localForm.des;
        // basic
        char.des = this.localForm.des;
        this.$store.dispatch("changeDetailChar", char);
        this.saveDocumentRevMod(5.91, 5); // business mod.
        this.$store.dispatch("changeDataSavePendingIndication", true);
      }
    }
  }
};
</script>
